import { tv } from 'tailwind-variants';

const labelStyles = tv({
  base: 'inline-flex text-sm mb-1',
  variants: {
    design: {
      external: 'text-secondary-one',
    },
    errored: {
      true: 'text-primary-two',
    },
  },
});

const containerStyles = tv({
  base: 'rounded-lg bg-white min-w-[175px] max-w-[450px] hover:cursor-pointer static box-border',
  variants: {
    design: {
      external: 'bg-zinc-50 h-8',
    },
    errored: {
      true: 'border border-primary-two',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});

const controlStyles = tv({
  base: 'hover:cursor-pointer',
  variants: {
    design: {
      external: 'bg-zinc-100 rounded',
    },
    focus: {
      false: 'border-gray-300 hover:border-gray-400',
    },
  },
  defaultVariants: {
    design: 'external',
  },
});

const placeholderStyles = tv({
  base: 'text-gray-500 py-0.5 text-sm',
  variants: {
    design: {
      external: 'text-sm',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});

const selectInputStyles = tv({
  base: 'ml-2 py-0.5 text-sm',
  variants: {
    design: {
      external: 'pl-1 py-0.5',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});

const valueContainerStyles = tv({
  base: 'p-0 gap-1',
  variants: {
    design: {
      external: '',
    },
    disabled: {
      true: 'text-gray-400',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});

const singleValueStyles = tv({
  base: 'leading-7 text-sm',
  variants: {
    design: {
      external: '',
    },
    disabled: {
      true: 'text-gray-400',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});
const multiValueStyles = tv({
  base: 'bg-gray-100 rounded-md items-center py-0.5 pl-2 pr-1 gap-1.5',
  variants: {
    design: {
      external: 'bg-gray-200 text-sm',
    },
    disabled: {
      true: 'text-gray-400',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});
const multiValueLabelStyles = tv({
  base: 'leading-6 py-0.5',
  variants: {
    design: {
      external: '',
    },
    disabled: {
      true: 'text-gray-400',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});
const multiValueRemoveStyles = tv({
  base: 'border border-gray-200 bg-white hover:bg-red-50 hover:text-red-800 text-gray-500 hover:border-red-300 rounded-md',
  variants: {
    design: {
      external: '',
    },
    defaultVariants: {
      design: 'external',
    },
  },
});

const indicatorsContainerStyles = tv({
  base: 'p-1 gap-1',
  variants: {
    design: {
      external: '',
    },
  },
  defaultVariants: {
    design: 'external',
  },
});

const clearIndicatorStyles = tv({
  base: 'text-gray-500 p-1 rounded-md hover:bg-red-50 hover:text-red-800',
  variants: {
    design: {
      external: '',
    },
  },
  defaultVariants: {
    design: 'external',
  },
});

const indicatorSeparatorStyles = tv({
  base: 'bg-gray-300 h-5 my-auto',
  variants: {
    design: {
      external: '',
    },
  },
  defaultVariants: {
    design: 'external',
  },
});

const dropdownIndicatorStyles = tv({
  base: 'p-1 hover:bg-gray-100 text-gray-500 rounded-md hover:text-black',
  variants: {
    design: {
      external: '',
    },
    error: {
      true: 'text-primary-two',
    },
  },
});

const menuStyles = tv({
  base: 'p-1 mt-2 border border-gray-200 bg-white rounded-lg',
  variants: {
    design: {
      external: 'shadow-lg z-[120] text-sm',
    },
  },
});

const groupHeadingStyles = tv({
  base: 'ml-3 mt-2 mb-1 text-gray-500 text-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

const optionStyles = tv({
  base: 'hover:cursor-pointer px-3 py-2 rounded text-sm',
  variants: {
    design: {
      external: '',
    },
    focus: {
      true: 'bg-zinc-100 active:bg-gray-200',
    },
    selected: {
      true: 'after:content-["✔"] after:ml-2 after:text-green-500 text-gray-500',
    },
  },
});

const noOptionsMessageStyles = tv({
  base: 'text-gray-500 p-2 bg-gray-50 border border-dashed border-gray-200 rounded-sm',
  variants: {
    design: {
      external: '',
    },
  },
});

export const multiSelectStyles = {
  label: labelStyles,
  control: controlStyles,
  container: containerStyles,
  placeholder: placeholderStyles,
  input: selectInputStyles,
  valueContainer: valueContainerStyles,
  singleValue: singleValueStyles,
  multiValue: multiValueStyles,
  multiValueLabel: multiValueLabelStyles,
  multiValueRemove: multiValueRemoveStyles,
  indicators: indicatorsContainerStyles,
  clearIndicator: clearIndicatorStyles,
  indicatorSeparator: indicatorSeparatorStyles,
  dropdownIndicator: dropdownIndicatorStyles,
  menu: menuStyles,
  groupHeading: groupHeadingStyles,
  option: optionStyles,
  noOptionsMessage: noOptionsMessageStyles,
};
